import { Component, Input, OnInit } from '@angular/core';
import { CompletedCareerPlan, CompletedCareerPlans } from 'src/app/models/career-plans';
import { CareerPlanHistoryService } from './career-plan-history.service';
import { Params } from '@angular/router';
import { ConfigService } from '../../../../services/config.service';

@Component({
  selector: 'app-career-plan-history',
  templateUrl: './career-plan-history.component.html',
  styleUrls: ['./career-plan-history.component.scss'],
})
export class CareerPlanHistoryComponent implements OnInit {
  @Input()
  completedCareerPlans: CompletedCareerPlans;

  careerPlanLabel: string = 'user.careerplans.label.name';
  pageName = 'user/career-plans/plan-history-item';

  constructor(private careerPlanHistoryServic: CareerPlanHistoryService, private configService: ConfigService) {}

  ngOnInit() {
    if (this.configService.isDigitalizaNavarra()) {
      this.careerPlanLabel = 'user.careerplans.label.name.E1184';
    }
  }

  buildQueryParams(careerPlan: CompletedCareerPlan): Params {
    return {
      completedCareerPlan: JSON.stringify(careerPlan),
    };
  }

  downloadCertificate(certificateUrl: string) {
    this.careerPlanHistoryServic.downloadCertificate(certificateUrl);
  }
}
